import {FormInputType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const teamMembersField: FormInputType = {
	id: 0,
	parent_id: 0,
	channel: 'input',
	type: 'number',
	label: copy?.teammembers?.label || 'Teamleden',
	name: 'teamleden',
	placeholder:
		copy?.teammembers?.placeholder || 'Aantal teamleden inclusief jezelf',
	required: true,
	mod: 'half',
	min: 1
}

export default teamMembersField
